<template>
  <div class="d-flex flex-column comparison-card">
    <div>
      <v-container class="pa-0 mb-1" fluid>
        <v-row>
          <v-col cols="12" class="py-0 d-flex justify-space-between align-center">
            <div>
              <div class="d-flex justify-center" @click.exact.stop="">
                <v-checkbox color="secondary" v-model="player.selected" hide-details dense class="ma-0 pa-0"
                  :disabled="!player.selected && selectionDisabled"
                  @change="onPlayerSelection($event)"></v-checkbox>
              </div>
            </div>
            <div class="d-flex">
              <v-btn x-small outlined :color="player.pinned ? 'secondary' : 'grey lighten-1'" class="me-2" @click="onPinClick(player)" v-if="showPinnedBtn"><v-icon x-small>beenhere</v-icon></v-btn>
              <v-btn x-small outlined color="grey lighten-1" class="me-2" @click="onRemoveFavClick(player)" v-if="showRemoveFavBtn"><v-icon x-small>delete</v-icon></v-btn>
              <v-btn x-small outlined color="grey lighten-1" @click="onRemoveClick()" v-if="removable"><v-icon x-small>close</v-icon></v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="d-flex position-relative cursor-pointer" @click.exact="onCardClick()">
      <div class="top right"></div>
      <div class="bottom right"></div>
      <v-container fluid v-if="player">
        <v-row>
          <v-col cols="2" sm="7" class="px-0 py-0 d-flex justify-center position-relative">
            <img
              :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/' + player.playerId + '.png'"
              :height="$vuetify.breakpoint.smAndDown ? '60' : '75'"
              contain
              @error="onImageLoadFailure($event)"
            />
          </v-col>
          <v-col cols="5" class="px-0 py-0" v-if="!$vuetify.breakpoint.smAndDown">
            <div class="d-flex flex-column align-center">
              <div class="d-flex justify-center">
                <v-chip class="monospace-font"
                  style="height: 24px; margin: 1px"
                  :color="getPositionChip(player.fieldPositionId)"
                  text-color="white"
                  small
                >{{ getPositionCode(player.fieldPositionId) }}</v-chip>
                <v-chip class="monospace-font mr-3"
                  v-if="player.secondFieldPositionId"
                  style="height: 24px; margin: 1px"
                  :color="getPositionChip(player.secondFieldPositionId)"
                  text-color="white"
                  small
                >{{ getPositionCode(player.secondFieldPositionId) }}</v-chip>
              </div>
              <div class="d-flex justify-center mt-2">
                <DriblabCountryFlag :iso="player.countryCode" ></DriblabCountryFlag>
                <DriblabCountryFlag className="ml-2" :iso="player.secondCountryCode" ></DriblabCountryFlag>
              </div>
              <div class="my-1 w-100 z-3" @click.exact.stop="onTeamClick()">
                <router-link
                  :to="'/team/'+player.teamId"
                  class="nav-link d-flex align-center w-100 justify-center"
                >
                  <img
                    :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + player.teamId + '.png'"
                    style="height: 22px; width: 22px;"
                  />
                  <div class="mx-2 body-2 text-ellipsis" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'">{{player.teamName}}</div>
                </router-link>
              </div>
            </div>
          </v-col>
          <v-col cols="10" sm="12" class="pl-2 pr-0 px-sm-0 py-0 d-flex flex-column justify-center">
            <v-divider></v-divider>
            <router-link :to="'/player/'+player.playerId" class="nav-link">
              <div class="d-flex flex-column">
                <div class="d-flex justify-space-between">
                  <span :class="$vuetify.theme.dark ? 'primary--text font-weight-bold' : 'secondary--text text--darken-2'">{{player.name}}</span>
                </div>
                <div class="d-flex justify-space-between">
                  <small
                    v-if="!$vuetify.breakpoint.smAndDown"
                    class="font-weight-light primary--text"
                  >{{player.firstName + ' ' + player.secondName}}</small>
                </div>
                <div class="d-flex align-center" v-if="$vuetify.breakpoint.smAndDown">
                  <div class="d-flex justify-start w-45">
                    <v-chip class="monospace-font"
                      style="height: 24px; margin: 1px"
                      :color="getPositionChip(player.fieldPositionId)"
                      text-color="white"
                      small
                    >{{ getPositionCode(player.fieldPositionId) }}</v-chip>
                    <v-chip class="monospace-font mr-3"
                      v-if="player.secondFieldPositionId"
                      style="height: 24px; margin: 1px"
                      :color="getPositionChip(player.secondFieldPositionId)"
                      text-color="white"
                      small
                    >{{ getPositionCode(player.secondFieldPositionId) }}</v-chip>
                  </div>
                  <div class="ml-2 d-flex justify-center px-1 w-20" v-if="$vuetify.breakpoint.smAndDown">
                    <DriblabCountryFlag :iso="player.countryCode" ></DriblabCountryFlag>
                    <DriblabCountryFlag className="ml-2" :iso="player.secondCountryCode" ></DriblabCountryFlag>
                  </div>
                  <div class="my-1 w-35 z-3" @click.exact.stop="onTeamClick()">
                    <router-link
                      :to="'/team/'+player.teamId"
                      class="nav-link d-flex align-center w-100 justify-center"
                    >
                      <img
                        :src="'https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/' + player.teamId + '.png'"
                        style="height: 22px; width: 22px;"
                      />
                      <div class="mx-2 body-2 text-ellipsis" :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'">{{player.teamName}}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </router-link>
            <v-divider></v-divider>
          </v-col>
          <v-col cols="12" sm="6" class="pl-2 pl-sm-0 pr-2 py-0 d-flex justify-space-between flex-sm-column">
            <small class="primary--text">{{$t('playerDetail.age')}}</small>
            <small class="primary--text">{{$t('playerDetail.height')}}</small>
            <small class="primary--text">{{$t('table.transfers.marketValue')}}</small>
            <small
              class="primary--text d-none d-sm-inline-block"
            >{{$t('playerDetail.contractEnd')}}</small>
            <small v-if="player.matchDate"
              class="primary--text d-none d-sm-inline-block"
            >{{$t('dashboards.nextGame')}}</small>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="pl-2 pr-2 px-sm-3 py-0 d-flex justify-space-between flex-sm-column align-end"
          >
            <small
              class="font-weight-bold primary--text" v-if="player.dob"
            >{{player.age}}('{{player.dob.slice(-2)}})</small>
            <small class="font-weight-bold primary--text">{{player.height || 'N/A'}}</small>
            <small class="font-weight-bold primary--text">
              <div class="d-flex">
                <span class="">{{currentUserCurrencySymbol}}</span>
                <h4
                  class="ml-1"
                  v-bind:class="{'mr-1':player.marketTrend && player.marketTrend != 'unknown'}"
                >{{ player.marketValue * 1000 | formatCash(currentUserRate) }}</h4>
                <v-icon v-if="player.marketTrend === 'up'" color="green" small>trending_up</v-icon>
                <v-icon v-if="player.marketTrend === 'same'" color="blue" small>drag_handle</v-icon>
                <v-icon v-if="player.marketTrend === 'down'" color="red" small>trending_down</v-icon>
              </div>
            </small>
            <small
              class="font-weight-bold primary--text d-none d-sm-inline-block"
            >{{contractExpirationDate}}</small>
            <small v-if="player.matchDate"
              class="primary--text d-none d-sm-inline-block text-ellipsis body-2"
            ><span v-if="$vuetify.breakpoint.lgAndUp">@{{player.matchDate}} </span>vs <router-link class="font-weight-bold text-ellipsis" 
              :class="$vuetify.theme.dark ? 'primary--text' : 'secondary--text text--darken-2'" :to="`/team/${vsTeamId}`"
                    target="_blank">{{vsTeamName}}</router-link></small>
          </v-col>
        </v-row>
      </v-container>
      <v-divider vertical></v-divider>
    </div>
  </div>
</template>

<script>

import { formatCash, getChipColorByPosition,getCurrencies,getPositionCode } from "../../utils/functions";
import * as moment from 'moment';
import DriblabCountryFlag from '../base/DriblabCountryFlag';


export default {
  name: "PlayerFavoriteCard",
  components: {
    DriblabCountryFlag
  },
  filters: {
    formatCash(n,rate) {
      return formatCash(n * rate)
    }
  },
  computed:{
    currentUser() {
      return this.$store.state.auth.user;
    },
    contractExpirationDate:function() {
      return moment(this.player.contractExpirationDate,'DD/MM/YYYY').locale(this.$store.getters['auth/language']).format("MMMM YYYY")
    },
    currentUserCurrency(){
      return this.$store.getters["auth/currency"];
    },
    currentUserRate(){
      let rate = this.currentUserCurrency === "EUR" ? 1 : this.$store.getters["exchange/rates"][this.$store.getters["auth/currency"]];
      return rate ? rate : 1;
    },
    currencies(){
      return getCurrencies();
    },
    currentUserCurrencySymbol(){
      let currentCurrencyObj = _.find(this.currencies,(c) => c.code === this.currentUserCurrency)
      return currentCurrencyObj.symbol;
    },
    vsTeamId(){
      let target = _.includes([this.player.teamId,this.player.nationalTeamId],this.player.homeTeamId) ? this.player.awayTeamId : this.player.homeTeamId;
      return target;
    },
    vsTeamName(){
      let target = _.includes([this.player.teamId,this.player.nationalTeamId],this.player.homeTeamId) ? this.player.awayTeamName : this.player.homeTeamName;
      return target;
    }
  },
  props: {
    player: {
      type: Object,
      default: false
    },
    removable: {
      type: Boolean,
      default:false
    },
    selectionDisabled: {
      type: Boolean,
      default:false
    },
    MAXIMUM_SELECTED_PLAYERS: {
      type: Number,
      default:5
    },
    showPinnedBtn: {
      type: Boolean,
      default:false
    },
    showRemoveFavBtn: {
      type: Boolean,
      default:false
    },
  },
  created() {},
  methods: {
    toOneDecimal: function(value) {
      return value && !isNaN(value) ? value.toFixed(1) : 0;
    },
    getPositionChip(position) {
      return  getChipColorByPosition(position)
    },
    onImageLoadFailure(event) {
      event.target.src =
        "https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0.png";
    },
    onCardClick() {
      this.$router.push({
        name: "player",
        params: { id: this.player.playerId }
      });
    },
    onTeamClick() {
      this.$router.push({ name: "team", params: { id: this.player.teamId } });
    },
    onRemoveClick(){
      this.$emit("removeClicked",true);
    },
    onPlayerSelection(selected){
      this.$emit("selectionChange",selected);
    },
    getPositionCode(position) {
      return getPositionCode(this.currentUser.fieldPositionCodeId, position);
    },
    onPinClick(event) {
      this.$emit("pinClicked", event);
    },
    onRemoveFavClick(event) {
      this.$emit("removeFavClicked", event);
    }
  }
};
</script>
<style lang="scss">
.top,
.bottom {
  position: absolute;
  width: 10px;
  height: 8px;
}
.top {
  top: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.42);
}
.bottom {
  bottom: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
}
.right {
  right: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.42);
  border-radius: 1px;
}
.remove-icon{
  position: absolute;
  top: -18px;
  left: -4px;
  width: 24px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/player/PlayerFavoriteCard.vue